export function getNormalizedUserEmail(email: string | null | undefined): string | null {
  const normalized = String(email || '')
    .trim()
    .toLowerCase();

  return normalized || null;
}
